/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    inner: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    inner: false,
};

const Hr = (props) => {
    const classNames = [
        's-hr',
        props.inner ? 's-hr--inner' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Hr.propTypes = propTypes;

Hr.defaultProps = defaultProps;

export default Hr;
